<template>
  <div>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title">
            {{'manage_property' | translate | titleize}}
          </h3>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{'manage_services' | translate | titleize}}
              </h3>
            </div>
          </div>
        </div>
        <div class="m-form m-form--state m-form--fit m-form--label-align-right pt-5">
          <div class="form-group m-form__group">
            <div class="m-section__content">
              <div  class="row">
                <template v-for="(service, index) in services" >
                  <div  :key="index" class="col-md-4 col-xs-4 pb-5">
                    <div class="m-form__group form-group row">
                      <div class="col-12 m-auto">
                        <span>
                          <label class="m-checkbox">
                            <input v-if="index===0" disabled type="checkbox" v-model="service.state">
                            <input v-else  type="checkbox" v-model="service.state" @click="changeStateServiceProp({id: service.id, state: !service.state})">
                            {{service.name | translate | capitalize}}
                            <span></span>
                          </label>
                        </span>
                      </div>                            
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>   
      </div>
      <template v-for="(service, index_s) in services" v-if="service.state === true" >
        <div :key="index_s" class="m-portlet m-portlet--tab">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">
                  {{service.name | translate | capitalize}}
                </h3>
              </div>
            </div>
          </div>  
          <div class="m-form m-form--state m-form--fit m-form--label-align-right pt-5">
            <form :data-vv-scope="`service${index_s}`">
              <div class="form-group m-form__group">
                <div class="m-section__content">
                  <div  class="row">
                    <template v-for="(element, index) in service.elements" >
                      <div  :key="index" :class="{ 'col-md-12 col-xs-12 pb-5': element.type === 'Map', 'col-md-4 col-xs-4 pb-5': element.type !== 'Map' }">
                        <div class="m-form__group form-group row">
                          <template v-if="element.type === 'Number'">
                            <label for="name_property">{{element.name | translate | capitalize}}</label>
                            <input :disabled="element.disabled" v-validate="element.validation" type="text" :name="element.name" class="form-control m-input" v-model="element.value">
                            <span v-show="errors.has(`service${index_s}.${element.name}`)" class="m-form__help m--font-danger">{{ errors.first(`service${index_s}.${element.name}`)}}</span>
                          </template>
                          <template v-else-if="element.type === 'String'">
                            <label for="name_property">{{element.name | translate | capitalize}}</label>
                            <input :disabled="element.disabled" v-validate="element.validation" type="text" :name="element.name" class="form-control m-input" v-model="element.value">
                            <span v-show="errors.has(`service${index_s}.${element.name}`)" class="m-form__help m--font-danger">{{ errors.first(`service${index_s}.${element.name}`) }}</span>                                  
                          </template>
                          <template v-else-if="element.type === 'Check'">
                            <div class="col-12 m-auto">
                              <span>
                                <label class="m-checkbox">
                                  <input :disabled="element.disabled" type="checkbox" v-model="element.value">
                                  {{element.name | translate | capitalize}}
                                  <span></span>
                                </label>
                              </span>
                            </div>
                          </template>
                          <template v-else-if="element.type === 'Select'">
                            <label>{{element.name | translate | capitalize}}</label>
                            <select  :disabled="element.disabled" v-validate="element.validation" v-model="element.value" :name="element.name" class="form-control m-input" >
                              <option v-for="(option,index) in element.option" :key="index" :value="option.name">
                                {{option.key | translate | capitalize}}
                              </option>                    
                            </select>
                            <span v-show="errors.has(`service${index_s}.${element.name}`)" class="m-form__help m--font-danger">{{ errors.first(`service${index_s}.${element.name}`) }}</span>                                  
                          </template>
                          <template v-else-if="element.type === 'Map'">
                            <label>
                              {{element.name | translate | capitalize}}
                            </label>
                            <div  v-map class="google-map">
                            <input :disabled="element.disabled" :id="`input_map_${index_s}_${index}`" class="controls" type="text" placeholder="Search Box">
                            <div :disabled="element.disabled" class="google-map" :id="`map_${index_s}_${index}`" :marker="element.value"></div> 
                            </div>                                
                          </template>
                          <template v-else-if="element.type === 'Toggle'">
                            <div class="col-3 m-auto">
                              <span class="m-switch m-switch--sm m-switch--icon">
                                <label class="mb-xl-0">
                                  <input :disabled="element.disabled" type="checkbox" checked="checked" v-model="element.value">
                                  <span></span>
                                </label>
                              </span>
                            </div> 
                            <label class="col-9 m-auto text-left">
                              {{element.name | translate | capitalize}}
                            </label>                              
                          </template>
                          <template v-else-if="element.type === 'File'">
                            <label >
                              {{element.name | translate | capitalize}}
                            </label>
                            <div class="input-group" >
                              <span class="input-group-btn btn-file cursor-pointer">
                                <button  :disabled="element.disabled" class="btn btn-brand" type="button">
                                  <i class="fa fa-upload"></i>
                                </button>
                                <input :disabled="element.disabled" :id="`file_${index_s}_${index}`" type="file" :accept="element.validation" @change="onFileChange($event, index_s, index)">
                              </span>
                              <input :disabled="element.disabled" type="text" class="form-control m-input" v-model="element.value">
                              <template v-if="filterInput(element.value.split('.').slice(-1)[0])">
                                <div class="m-dropdown m-dropdown--up m-dropdown--inline m-dropdown--smallest m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" data-dropdown-toggle="click">
                                  <button class="btn btn-brand m-dropdown__toggle" type="button" >
                                      <i class="fa fa-eye"></i>
                                  </button>   
                                  <div class="m-dropdown__wrapper custom-wrapper" style="left:auto;width:auto;margin-right: 0px;">
                                    <span class="m-dropdown__arrow m-dropdown__arrow"></span>
                                    <div class="m-dropdown__inner">
                                      <div class="m-dropdown__body">
                                        <div class="m-dropdown__content">
                                          <img class="w-100 min-150" :src="element.file">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>       
                          </template>
                          <template v-else-if="element.type === 'Date'">
                            <label>{{element.name | translate | capitalize}}</label>
                            <input :disabled="element.disabled" type="date" :name="element.name" class="form-control m-input" v-model="element.value">
                          </template>
                          <template v-else-if="element.type === 'Time'">
                            <label>{{element.name | translate | capitalize}}</label>
                            <input :disabled="element.disabled" type="time" :name="element.name" class="form-control m-input" v-model="element.value">
                          </template>                             
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__foot--fit m--align-right">
                <div class="m-form__actions">
                  <button @click.prevent="cleanForm(index_s)" class="btn btn-secondary">
                    {{'cancel' | translate | capitalize}}
                  </button>
                  <button @click.prevent="validateForm(service.elements,index_s)" class="btn btn-primary">
                    {{'submit' | translate | capitalize}}
                  </button>
                </div>
              </div>
            </form>
          </div>   
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      services: [],
      maps: []
    }
  },
  created () {
    this.$spinner.show()
    this.getPropertyInfo(this.user_data.profiles[0].profile_id)
      .then((response) => {
        if (response.data.status === 200) {
          this.services = response.data.content.services
        }
        this.$spinner.remove()
      })
      .catch((err) => {
        console.log(err)
        this.$spinner.remove()
      })
  },
  computed: {
    ...mapGetters({user_data: 'getUserData'})
  },
  methods: {
    ...mapActions(['getPropertyInfo', 'changeStateServiceProp', 'editConfigs']),
    filterInput (type) {
      if (type === 'png' || type === 'jpg' || type === 'gif') {
        return true
      }
      return false
    },
    onFileChange (event, index, sub_index) {
      var files = event.target.files || event.dataTransfer.files
      if (!files.length) {
        return
      }
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.services[index].elements[sub_index].file = e.target.result
      }
      reader.readAsDataURL(files[0])
      this.services[index].elements[sub_index].value = files[0].name
    },
    cleanForm (index) {
      for (let i = 0; i < this.services[index].elements.length; i++) {
        if (this.services[index].elements[i].type === 'Map') {
          let local_map = document.getElementById(`map_${index}_${i}`)
          let cord = this.services[index].elements[i].original_value.split('#')
          if (cord.length < 2) {
            cord[0] = 4.671810000000001
            cord[1] = -74.15522699999997
          }
          local_map.g_map.setCenter({lat: parseFloat(cord[0]), lng: parseFloat(cord[1])})
          local_map.g_marker.setPosition({lat: parseFloat(cord[0]), lng: parseFloat(cord[1])})
        } else if (this.services[index].elements[i].value !== this.services[index].elements[i].original_value) {
          this.$set(this.services[index].elements[i], 'value', JSON.parse(JSON.stringify(this.services[index].elements[i].original_value)))
          if (this.services[index].elements[i].type === 'File') {
            this.$set(this.services[index].elements[i], 'file', JSON.parse(JSON.stringify(this.services[index].elements[i].original_file)))
          }
        }
      }
    },
    validateForm (configs, index_s) {
      let self = this
      this.$validator.validateAll(`service${index_s}`).then((result) => {
        if (result) {
          this.$spinner.show()
          for (let i = 0; i < configs.length; i++) {
            if (configs[i].type === 'Map') {
              configs[i].value = document.getElementById(`map_${index_s}_${i}`).getAttribute('marker')
            }
          }
          this.editConfigs(configs)
            .then((result) => {
              this.$spinner.remove()
              if (result.status === 200) {
                self.services[index_s].elements = result.data.content
                this.$toast('edit_property_message')
              }
            })
            .catch((err) => {
              this.$spinner.remove()
              this.$toast('edit_property_error', 4)
              console.log(err)
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.btn-file {
    position: relative;
    overflow: hidden;
}
.btn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    background: white;
    cursor: inherit;
    display: block;
}
.google-map {
  width: 100%;
  height: 30vw;
  margin: 0 auto;
  background: #ebedf2;
  min-height: 300px
}
.controls {
  margin-top: 10px;
  border: 1px solid transparent;
  border-radius: 2px 0 0 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  height: 32px;
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 40vw;
}

.controls:focus {
  border-color: #4d90fe;
}

.pac-container {
  font-family: Roboto;
}

#type-selector {
  color: #fff;
  background-color: #4d90fe;
  padding: 5px 11px 0px 11px;
}

#type-selector label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}
#target {
  width: 345px;
}
.m-demo__preview {
  padding: 15px 0px 0px 0px
}
.min-150 {
  min-width:150px
}
.custom-wrapper {
 left:auto;
 width:auto;
 margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// AdminProperty.vue